import { createSlice } from "@reduxjs/toolkit";
import {
  ClientBillingInfo,
  ClientExternalData,
} from "../../types/clients-module-types";
import { HUBSPOT } from "../../../SharedModule/utils/constants";

type ClientBillingInfoState = {
  isBillingInfoLoading: boolean;
  isBillingInfoLoaded: boolean;
  clientBillingInfo: ClientBillingInfo | null;
  actualClientExternalData: ClientExternalData | null;
};

const initialState: ClientBillingInfoState = {
  isBillingInfoLoading: false,
  isBillingInfoLoaded: false,
  clientBillingInfo: null,
  actualClientExternalData: null,
};

export const clientBillingInfoSlice = createSlice({
  name: "clientBillingInfo",
  initialState,
  reducers: {
    loadBillingInfoTab: (state, action) => {
      state.actualClientExternalData =
        action.payload.data.clientExternalData.find(
          (e: ClientExternalData) => e.systemName === HUBSPOT
        );
      state.clientBillingInfo = action.payload.data.billingInfo;
      state.isBillingInfoLoading = false;
      state.isBillingInfoLoaded = true;
    },
    setIsBillingInfoLoading: (state, action) => {
      state.isBillingInfoLoading = action.payload;
    },
    setIsBillingInfoLoaded: (state, action) => {
      state.isBillingInfoLoaded = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadBillingInfoTab,
  setIsBillingInfoLoading,
  setIsBillingInfoLoaded,
} = clientBillingInfoSlice.actions;

export const IsBillingInfoLoading = (state: any) => {
  return state.clientBillingInfo.isBillingInfoLoading;
};

export const IsBillingInfoLoaded = (state: any) => {
  return state.clientBillingInfo.isBillingInfoLoaded;
};

export const SelectClientBillingInfo = (state: any) => {
  return state.clientBillingInfo.clientBillingInfo;
};

export const SelectActualClientExternalData = (state: any) => {
  return state.clientBillingInfo.actualClientExternalData;
};

export default clientBillingInfoSlice.reducer;
